// ISO 3166-1
const countriesList = [
  "United States of America",
  "Canada",
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo (Democratic Republic of the)",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (Democratic Peoples Republic of)",
  "Korea (Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao Peoples Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia (the former Yugoslav Republic of)",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Province of China[a]",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom of Great Britain and Northern Ireland",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];

export const countries = countriesList.map(item => ({
    label: item,
    value: item,
}));

type State = {
  label: string;
  value: string;
}

export const usStates: State[] = [
  {label: "Alabama", value: "AL"},
  {label: "Alaska", value: "AK"},
  {label: "Arizona", value: "AZ"},
  {label: "Arkansas", value: "AR"},
  {label: "California", value: "CA"},
  {label: "Colorado", value: "CO"},
  {label: "Connecticut", value: "CT"},
  {label: "Delaware", value: "DE"},
  {label: "Florida", value: "FL"},
  {label: "Georgia", value: "GA"},
  {label: "Hawaii", value: "HI"},
  {label: "Idaho", value: "ID"},
  {label: "Illinois", value: "IL"},
  {label: "Indiana", value: "IN"},
  {label: "Iowa", value: "IA"},
  {label: "Kansas", value: "KS"},
  {label: "Kentucky", value: "KY"},
  {label: "Louisiana", value: "LA"},
  {label: "Maine", value: "ME"},
  {label: "Maryland", value: "MD"},
  {label: "Massachusetts", value: "MA"},
  {label: "Michigan", value: "MI"},
  {label: "Minnesota", value: "MN"},
  {label: "Mississippi", value: "MS"},
  {label: "Missouri", value: "MO"},
  {label: "Montana", value: "MT"},
  {label: "Nebraska", value: "NE"},
  {label: "Nevada", value: "NV"},
  {label: "New Hampshire", value: "NH"},
  {label: "New Jersey", value: "NJ"},
  {label: "New Mexico", value: "NM"},
  {label: "New York", value: "NY"},
  {label: "North Carolina", value: "NC"},
  {label: "North Dakota", value: "ND"},
  {label: "Ohio", value: "OH"},
  {label: "Oklahoma", value: "OK"},
  {label: "Oregon", value: "OR"},
  {label: "Pennsylvania", value: "PA"},
  {label: "Rhode Island", value: "RI"},
  {label: "South Carolina", value: "SC"},
  {label: "South Dakota", value: "SD"},
  {label: "Tennessee", value: "TN"},
  {label: "Texas", value: "TX"},
  {label: "Utah", value: "UT"},
  {label: "Vermont", value: "VT"},
  {label: "Virginia", value: "VA"},
  {label: "Washington", value: "WA"},
  {label: "West Virginia", value: "WV"},
  {label: "Wisconsin", value: "WI"},
  {label: "Wyoming", value: "WY"}
]
